'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useEffect, useState } from 'react'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import PropTypes from 'prop-types'

export const ExpertiseAreaSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx = {},
  size = 'small',
  required,
  errors = {}
}) => {
  const { fetchExpertiseAreas, expertAreas } = useLookupsStore()
  const [options, setOptions] = useState(testData || expertAreas || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(expertAreas || [])
  }, [testData, expertAreas])

  useEffect(() => {
    if (testData || expertAreas?.length) return
    fetchExpertiseAreas()
  }, [testData, expertAreas, fetchExpertiseAreas])

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  return (
    <div
      data-testid="ExpertiseAreaSelect"
      style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}
    >
      <ReactSelectMenu
        label="Expertise area"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="expertiseAreaId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="expertiseAreaId"
        showIdInResults={false}
        name="expertiseAreaId"
        size={size}
        required={required}
        errors={errors}
        menuZindex={9999999}
      />
    </div>
  )
}

ExpertiseAreaSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
